export var LEGACY_URL='/register_legacy';export var LEGACY_URL_CONNECT_REGISTER='/connect_register';export var URL_TYPE_REGISTER='register';